import { render, staticRenderFns } from "./sin-section.vue?vue&type=template&id=3b1b8a8e"
import script from "./sin-section.vue?vue&type=script&lang=js"
export * from "./sin-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports